/** Bound in-flight async work while keeping Promise.allSettled semantics. */
export async function mapLimitSettled<T, R>(
  items: readonly T[],
  limit: number,
  mapper: (item: T, index: number) => Promise<R>,
  onProgress?: (completed: number, total: number) => void
): Promise<PromiseSettledResult<R>[]> {
  const total = items.length;
  if (total === 0) return [];

  const results = new Array<PromiseSettledResult<R>>(total);
  let cursor = 0;
  let completed = 0;
  const workerCount = Math.max(1, Math.min(limit, total));

  const run = async () => {
    while (true) {
      const index = cursor;
      cursor += 1;
      if (index >= total) return;
      try {
        const value = await mapper(items[index], index);
        results[index] = { status: "fulfilled", value };
      } catch (reason) {
        results[index] = { status: "rejected", reason };
      }
      completed += 1;
      onProgress?.(completed, total);
    }
  };

  await Promise.all(Array.from({ length: workerCount }, () => run()));
  return results;
}
